<template>
<div>
  <div class="wistia_embed wistia_async_ecqz9o9guw">
    &nbsp;
  </div>

  <div
    id="faith_leaders_choose"
    class="tbk-vid-embed"
  >
    <a
      id="dan_gerrietts"
      class="embedded_video"
      href="#wistia_06pglwcg5t?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="grace_gravelle"
      class="embedded_video"
      href="#wistia_pjunmlptxf?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="john_nelson"
      class="embedded_video"
      href="#wistia_rslxjmwucd?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="melissa_pohlman"
      class="embedded_video"
      href="#wistia_h55eomk3gr?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="mark_aune"
      class="embedded_video"
      href="#wistia_34dcos5pxf?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('ecq', 24, this.showSelect)

    this.tbk.loadCrossTime('06p', 198, this.showSelect)
    this.tbk.loadCrossTime('pju', 66, this.showSelect)
    this.tbk.loadCrossTime('rsl', 105, this.showSelect)
    this.tbk.loadCrossTime('h55', 125, this.showSelect)
    this.tbk.loadCrossTime('34d', 131, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        '06p': this.tbk.autoPlay,
        pju: this.tbk.autoPlay,
        rsl: this.tbk.autoPlay,
        h55: this.tbk.autoPlay,
        '34d': this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style lang="sass" scoped>
.tbk-vid-embed
  &:before
    content: ""
    display: block
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
#faith_leaders_choose
  display: none
  a
    text-decoration: none
#dan_gerrietts
  position: absolute
  top: 0
  left: 0
  width: calc(100% / 3)
  height: 50%
#grace_gravelle
  position: absolute
  top: 0
  left: calc((100% / 3) * 2)
  width: calc(100% / 3)
  height: 50%
#john_nelson
  position: absolute
  top: 50%
  left: 0
  width: calc(100% / 3)
  height: 50%
#melissa_pohlman
  position: absolute
  top: 50%
  left: calc((100% / 3) * 1)
  width: calc(100% / 3)
  height: 50%
#mark_aune
  position: absolute
  top: 50%
  left: calc((100% / 3) * 2)
  width: calc(100% / 3)
  height: 50%
</style>
